if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
/* DEBUT - Zoom photo au pincement et a la roulette */
(() => {
  const Modal = customElements.get('product-modal');
  if (!Modal || Modal.prototype.photoZoomInstalled) return;
  Modal.prototype.photoZoomInstalled = true;

  const originalShow = Modal.prototype.show;

  Modal.prototype.show = function (opener) {
    originalShow.call(this, opener);

    const area = this.querySelector('.product-media-modal__content');
    const image = area.querySelector('img.active');
    if (this.resetPhotoZoom) this.resetPhotoZoom();

    area.style.overflow = image ? 'hidden' : '';
    if (!image) return;

    let scale = 1;
    let x = 0;
    let y = 0;
    let previous = null;
    const pointers = new Map();
    const controller = new AbortController();
    const options = { signal: controller.signal };

    image.style.touchAction = 'none';
    image.style.transformOrigin = 'center';
    image.style.userSelect = 'none';

    const draw = () => {
      const maxX = image.offsetWidth * (scale - 1) / 2;
      const maxY = image.offsetHeight * (scale - 1) / 2;
      x = Math.max(-maxX, Math.min(maxX, x));
      y = Math.max(-maxY, Math.min(maxY, y));
      image.style.transform =
        `translate(${x}px, ${y}px) scale(${scale})`;
      image.style.cursor = scale > 1 ? 'grab' : 'default';
    };

    const zoom = (next, clientX, clientY) => {
      next = Math.max(1, Math.min(4, next));
      const box = image.getBoundingClientRect();
      const centerX = box.left + box.width / 2;
      const centerY = box.top + box.height / 2;
      const ratio = next / scale;
      x += (clientX - centerX) * (1 - ratio);
      y += (clientY - centerY) * (1 - ratio);
      scale = next;
      draw();
    };

    const gesture = () => {
      const points = [...pointers.values()];
      if (!points.length) return null;
      if (points.length === 1) {
        return { x: points[0].x, y: points[0].y, distance: 0 };
      }
      return {
        x: (points[0].x + points[1].x) / 2,
        y: (points[0].y + points[1].y) / 2,
        distance: Math.hypot(
          points[0].x - points[1].x,
          points[0].y - points[1].y
        )
      };
    };

    area.addEventListener('wheel', (event) => {
      event.preventDefault();
      zoom(
        scale * Math.exp(-event.deltaY * 0.002),
        event.clientX,
        event.clientY
      );
    }, { ...options, passive: false });

    area.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      event.preventDefault();
      pointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY
      });
      area.setPointerCapture(event.pointerId);
      previous = gesture();
    }, options);

    area.addEventListener('pointermove', (event) => {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, {
        x: event.clientX,
        y: event.clientY
      });
      const current = gesture();

      if (previous) {
        if (current.distance && previous.distance) {
          zoom(
            scale * current.distance / previous.distance,
            current.x,
            current.y
          );
        }
        if (scale > 1) {
          x += current.x - previous.x;
          y += current.y - previous.y;
          draw();
        }
      }
      previous = current;
    }, options);

    const finish = (event) => {
      event.stopPropagation();
      pointers.delete(event.pointerId);
      previous = gesture();
    };

    area.addEventListener('pointerup', finish, options);
    area.addEventListener('pointercancel', finish, options);
    area.addEventListener('lostpointercapture', finish, options);
    area.addEventListener('dragstart', (event) => {
      event.preventDefault();
    }, options);

    this.resetPhotoZoom = () => {
      controller.abort();
      pointers.clear();
      image.style.transform = '';
      image.style.transformOrigin = '';
      image.style.touchAction = '';
      image.style.userSelect = '';
      image.style.cursor = '';
    };

    draw();
  };
})();
/* FIN - Zoom photo au pincement et a la roulette */
